import { z } from "zod/v4";
import { checkVendedor } from "../api/check-vendedor";
import { useEffect } from "react";
import useFetch from "@/hooks/use-fetch";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import { DataCache } from "@/components/display";
import { Form, FormProps } from "@/components/form";

export const addVendedorFormSchema = z.object({
    numDocumento: z.string().nonempty("Este campo es requerido"),
    nombre: z.string().nonempty("Este campo es requerido"),
    porcentajeComision: z.number({ message: "Este campo es requerido" }).min(0, "El valor debe ser entre 0 y 100").max(100, "El valor debe ser entre 0 y 100"),
    email: z.email(),
    telefono: z.string(),
    direccion: z.string()
})

export default function AddVendedorForm({
    form,
    ...props
}: FormProps<z.infer<typeof addVendedorFormSchema>>) {
    const { fetch, value, loading, error } = useFetch(async (value: string) => {
        if (value) return await checkVendedor(value);
        return undefined;
    }, { debounceMs: 500 });

    const shouldDisable = value === undefined || loading || Boolean(error);

    useEffect(() => {
        if (shouldDisable || !value) {
            form.setFieldValue("nombre", "");
            form.setFieldValue("email", "");
            form.setFieldValue("telefono", "");
            form.setFieldValue("direccion", "");
            form.setFieldValue("porcentajeComision", "" as any);
        } else {
            form.setFieldValue("nombre", value.nombre);
            form.setFieldValue("email", value.email);
            form.setFieldValue("telefono", value.telefono);
            form.setFieldValue("direccion", value.direccion);
            form.setFieldValue("porcentajeComision", value.porcentajeComision);
        }
    }, [value, loading, error])

    return <Form form={form} gap={3} {...props}>
        <Collapse in={!loading && value !== undefined} sx={{ marginY: "-10px" }}>
            <DataCache data={value}>
                {value => <Alert severity="info">
                    {value == null ? "Se agregara una nueva persona" : "Se editara una persona existente"}
                </Alert>}
            </DataCache>
        </Collapse>
        <Form.TextField name="numDocumento" label="N° Documento" onChange={e => fetch(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />
        <Form.TextField name="nombre" label="Nombre" disabled={shouldDisable} />
        <Form.NumberField name="porcentajeComision" label="Comisión (%)" disabled={shouldDisable} min={0} max={100} />
        <Form.TextField name="email" label="Email" disabled={shouldDisable} />
        <Form.TextField name="telefono" label="Telefono" disabled={shouldDisable} />
        <Form.TextField name="direccion" label="Dirección" disabled={shouldDisable} />
        <Form.SubmitButton disabled={shouldDisable}>Guardar</Form.SubmitButton>
    </Form>
}